import Request from "../../shared/utils/_request";

class Client {
  constructor() {}
  //客户管理列表接口
  getList(payload) {
    return Request.post("company/search", payload);
  }
  getDetail(payload) {
    return Request.post("company/detail", payload);
  }
  //添加HR接口
  addHr(payload) {
    return Request.post("company/HrCompanyContacter/create", payload);
  }

  //获取合同列表接口
  getContract(payload) {
    return Request.post("company/HrCompanyContract/get-list", payload);
  }
  //添加合同接口
  addContract(payload) {
    return Request.post("company/HrCompanyContract/create", payload);
  }

  //编辑合同接口
  editContract(payload) {
    return Request.post("company/HrCompanyContract/update", payload);
  }

  //审核不通过
  reviewUnPass(payload) {
    return Request.post("company/HrCompanyAudit/reject", payload);
  }

  //审核通过
  reviewPass(payload) {
    return Request.post("company/HrCompanyAudit/accept", payload);
  }

  //新建公司
  addCompany(payload) {
    return Request.post("company/create", payload);
  }

  //编辑公司
  editCompany(payload) {
    return Request.post("company/update", payload);
  }

  //企查查查询公司名字
  searchCompany(payload) {
    return Request.post("common/business-data/search", payload);
  }

  //添加拜访记录
  editLook(payload) {
    return Request.post("company/hr-company-remark/create", payload);
  }

  //查看拜访记录
  showLook(payload) {
    return Request.post("company/hr-company-remark/get-all", payload);
  }

  // 转移客户
  transfer(payload) {
    return Request.post("company/transform", payload);
  }
}

export const client = new Client();
